export const usePageHead = () => {
  const { gtm } = useRuntimeConfig().public
  const { LocalConfigurationStore } = stores()

  useHead({
    link: [
      {
        rel: 'icon',
        type: 'image/x-icon',
        href: LocalConfigurationStore.value?.siteInfo?.faviconUrl,
      },
      {
        id: 'matos-styles',
        rel: 'stylesheet',
        href: `/assets/matos/css/styles.css`,
      },
      //{
      //  rel: 'stylesheet',
      //  href: 'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap',
      //},
    ],
    script: [
      ...(gtm?.enable
        ? [
            {
              innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtm?.id}');`,
              type: 'text/javascript',
            },
          ]
        : []),
    ],
  })
}
